export const getIsUserRegister = () => {
  return JSON.parse(localStorage.getItem('isEmailRegister'));
};
